import { api_ } from '@shared/plugIn/axios';
import { LowerRole } from '@shared/types';

import { GiftStoreRole } from '../giftOrder/giftOrder.interface';
import {
  GiftCouponForStore,
  GiftCouponRedeemStatus,
  GiftCouponRequestDto,
  GiftCouponStatistics,
} from './giftCoupon.interface';

// 공유 처리 (ShareStatus: NotShared → Shared)
export const shareCoupon = async (
  id: string,
  role: GiftStoreRole,
): Promise<GiftCouponForStore> => {
  const response = await api_.post<GiftCouponForStore>(
    `/${role}/gift-coupon/share/${id}`,
  );
  return response.data;
};

// 공유 취소 (ShareStatus: Shared → NotShared)
export const unshareCoupon = async (
  id: string,
  role: GiftStoreRole,
): Promise<GiftCouponForStore> => {
  const response = await api_.post<GiftCouponForStore>(
    `/${role}/gift-coupon/unshare/${id}`,
  );
  return response.data;
};

// 전달 확인 (confirmedAt 기록 + memo optional)
export const confirmCoupon = async (
  id: string,
  role: GiftStoreRole,
  memo?: string,
): Promise<GiftCouponForStore> => {
  const response = await api_.post<GiftCouponForStore>(
    `/${role}/gift-coupon/confirm-share/${id}`,
    memo ? { memo } : {},
  );
  return response.data;
};

// 조회 처리 (ShareStatus: Shared → Viewed)
export const viewCoupon = async (
  id: string,
  role: GiftStoreRole = LowerRole.Public,
): Promise<GiftCouponForStore> => {
  const response = await api_.post<GiftCouponForStore>(`/${role}/gift-coupon/view/${id}`);
  return response.data;
};

// 교환 신청 (RedeemStatus: Available → Requested)
export const requestCouponRedemption = async (
  id: string,
  dto: GiftCouponRequestDto,
  role: GiftStoreRole = LowerRole.Public,
): Promise<GiftCouponForStore> => {
  const response = await api_.post<GiftCouponForStore>(
    `/${role}/gift-coupon/request/${id}`,
    dto,
  );
  return response.data;
};

// 발송 처리 (RedeemStatus: Requested → Delivered)
export interface DeliverCouponDto {
  priceWhole: number;
  priceRetail: number;
  priceRebate: number;
}

export const deliverCoupon = async (
  id: string,
  dto: DeliverCouponDto,
): Promise<GiftCouponForStore> => {
  const response = await api_.patch<GiftCouponForStore>(`/admin/gift-coupon/${id}`, {
    redeemStatus: GiftCouponRedeemStatus.Delivered,
    'gifticon.deliveredAt': new Date().toISOString(),
    'gifticon.priceWhole': dto.priceWhole,
    'gifticon.priceRetail': dto.priceRetail,
    'gifticon.priceRebate': dto.priceRebate,
  });
  return response.data;
};

// 발송불가 처리 (RedeemStatus: Requested → Rejected)
export const rejectCoupon = async (id: string): Promise<GiftCouponForStore> => {
  const response = await api_.patch<GiftCouponForStore>(`/admin/gift-coupon/${id}`, {
    redeemStatus: GiftCouponRedeemStatus.Rejected,
  });
  return response.data;
};

// 수신자 전화번호 수정 (Admin)
export const updateRecipientPhone = async (
  id: string,
  phoneNumber: string,
): Promise<GiftCouponForStore> => {
  const response = await api_.patch<GiftCouponForStore>(`/admin/gift-coupon/${id}`, {
    'recipient.phoneNumber': phoneNumber,
  });
  return response.data;
};

// 쿠폰 통계 조회 (Admin)
export const fetchGiftCouponStatistics = async (): Promise<GiftCouponStatistics> => {
  const response = await api_.get<GiftCouponStatistics>(
    `/${LowerRole.Admin}/gift-coupon/statistics`,
  );
  return response.data;
};
